import { render, staticRenderFns } from "./_Elect.vue?vue&type=template&id=0b8be1a6&"
import script from "./_Elect.vue?vue&type=script&lang=js&"
export * from "./_Elect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports